import type {
  OpeningConfigDB,
  OpeningConfigLine,
  OpeningConfigValidationResponse,
  OpeningMode,
} from '@gozoki/api-types'
import { OPENING_MODE_VALUES } from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

const defaultDoorConfig: OpeningConfigDB = {
  1: [
    {
      beginTime: '00:00',
      openingMode: OPENING_MODE_VALUES[0],
    },
  ],
  2: [
    {
      beginTime: '00:00',
      openingMode: OPENING_MODE_VALUES[0],
    },
  ],
  3: [
    {
      beginTime: '00:00',
      openingMode: OPENING_MODE_VALUES[0],
    },
  ],
  4: [
    {
      beginTime: '00:00',
      openingMode: OPENING_MODE_VALUES[0],
    },
  ],
  5: [
    {
      beginTime: '00:00',
      openingMode: OPENING_MODE_VALUES[0],
    },
  ],
  6: [
    {
      beginTime: '00:00',
      openingMode: OPENING_MODE_VALUES[0],
    },
  ],
  7: [
    {
      beginTime: '00:00',
      openingMode: OPENING_MODE_VALUES[0],
    },
  ],
}

export const fetchConfigDoor = async (storeId: number) => {
  const response = await gozokiApiWithAuth.get<OpeningConfigDB | null>(
    `/stores/${storeId}/open/config`,
  )
  return response.data ?? defaultDoorConfig
}

export const updateConfigDoor = async (
  storeId: number,
  body: Record<number, OpeningConfigLine[]>,
) => {
  const response = await gozokiApiWithAuth.post<OpeningConfigValidationResponse>(
    `/stores/${storeId}/open/config`,
    body,
  )
  return response.data
}

export const openDoor = async (kioskId: number, granted: boolean) => {
  const response = await gozokiApiWithAuth.post(`/kiosk/${kioskId}/open-client`, { granted })
  return response.data
}

export const respondToPreAuthorizationRequest = async (kioskId: number, granted: boolean) => {
    const response = await gozokiApiWithAuth.post(
        `/kiosk/${kioskId}/pre-authorization-client`,
        { granted }
    );
    return response.data;
};

export const fetchStoreOpeningState = async (storeId: number) => {
  const response = await gozokiApiWithAuth.get<
    Promise<{
      success: boolean
      openingMode: OpeningMode | null
      error: string | null
    }>
  >(`/stores/${storeId}/open/state`)
  return response.data
}

export const triggerDoorConfiguration = async () => {
  const response = await gozokiApiWithAuth.post<{
    success: boolean
    message: string
    timestamp: string
  }>('/cron/door-configuration')
  return response.data
}
